export class NotImplementedError extends Error {
    constructor() {
        super('Method Not Implemented')
    }
}
